import { UAParser } from 'ua-parser-js';

/**
 * Replaces next-useragent (unmaintained, required react at runtime without
 * declaring it, which broke Vercel's lambda file tracing). Flag semantics
 * follow next-useragent's parse(), with both ua-parser-js 0.7 and 2.x label
 * variants accepted where v2 renamed them ('Mac OS' → 'macOS', 'Chrome' →
 * 'Mobile Chrome' on mobile). 'Safari' deliberately excludes 'Mobile Safari',
 * matching the old behavior that callers compensate for.
 */
export const parseUserAgent = (source: string) => {
  const result = new UAParser(source).getResult();

  const browser = result.browser.name;
  const os = result.os.name;
  const type = result.device.type;
  const mobile = type === 'mobile';
  const ios = os === 'iOS';

  return {
    browserVersion: parseFloat(result.browser.version ?? ''),
    isAndroid: os === 'Android',
    isChrome: browser === 'Chrome' || browser === 'Mobile Chrome',
    isIE: browser === 'IE',
    isIos: ios,
    isIphone: mobile && ios,
    isMac: os === 'macOS' || os === 'Mac OS',
    isMobile: mobile,
    isSafari: browser === 'Safari',
    isTablet: type === 'tablet',
    source,
  };
};
